import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const AnalyzedCategories = ({ isLoadingStats, stats }) => {
  return (
    <div className="categories-wrapper">
      {isLoadingStats ? (
        <div className="categorias-container">
          <br></br>
          <Skeleton height={300} width="100%" />
        </div>
      ) : (
        <div className="categories-container">
          <span className="categories-title">
            Categorías analizadas: {stats.categories.length}
          </span>
          <ul className="categories-list">
            {stats.categories.map((category, index) => (
              <li key={index} className="category-item">
                {category.replace(/['"]/g, '')}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AnalyzedCategories;
